import {CxEvent} from '@spartacus/core';
import {AdobeTrackingProductData} from '../../../models/adobe-tracking-data';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';

export class AddToCartEvent extends CxEvent {
  static readonly type = 'AddToCartEvent';
  productCode: string;
  quantity: number;
  entry?: OrderEntry;
  products: AdobeTrackingProductData[];
  currencyIso: string;
}
